import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	cardWrapper: {
		border        : `1px solid ${ theme.other.colors.border.primary }`,
		borderRadius  : "10px",
		padding       : "1rem",
		display       : "flex",
		flexDirection : "column",
		gap           : "2rem"
	},
	headerWrapper: {
		display        : "flex",
		justifyContent : "space-between"
	},
	leftSide: {
		display    : "flex",
		gap        : "1rem",
		alignItems : "center"
	},
	imageBanner: {
		width        : "4rem",
		height       : "4rem",
		borderRadius : "50%"
	},
	option: {
		width          : "100%",
		border         : theme.other.darkMode ? `1px solid ${ theme.other.paletteNew.darkModeWhite20 }` : `1px solid ${ theme.other.paletteNew.darkModeDarkGrey20 }`,
		fontSize       : "1.4rem",
		color          : "#000",
		borderRadius   : "10px",
		display        : "flex",
		justifyContent : "space-between",
		position       : "relative",
		cursor         : "pointer"
	},
	endButtonSection: {
		display        : "flex",
		justifyContent : "flex-end"
	},
	endButton: {
		color        : "#e02020",
		borderRadius : "10px",
		border       : "1px solid #e02020",
		padding      : "0.5rem 2rem",
		fontSize     : "1.3rem",
		cursor       : "pointer"
	},
	progressPercentage: {
		backgroundColor : ( props?.maxVotesFlag && !props?.isActive ) ? "#439aff" : "rgba(231, 231, 231, 0.5)",
		position        : "absolute",
		width           : `${ props?.percentage }%`,
		height          : "100%",
		borderRadius    : "10px"
	},
	infoTextWrapper: {
		display       : "flex",
		flexDirection : "column"
	},
	statsContainer: {
		display    : "flex",
		alignItems : "center",
		flexWrap   : "wrap"
	},
	liveText: {
		color    : "#757575",
		fontSize : "1.1rem"
	},
	questionText: {
		fontWeight : "500",
		wordWrap   : "break-word"
	},
	nameText: {
		fontWeight: "500"
	},
	dot: {
		borderRadius    : "50%",
		backgroundColor : "#757575",
		height          : "3px",
		width           : "3px",
		margin          : "0 0.5rem"
	},
	verifiedIcon: {
		height : "1.4rem",
		width  : "1.4rem",
		margin : "0 0.5rem"
	},
	nameContainer: {
		display    : "flex",
		alignItems : "center"
	},
	overlay: {
		backgroundColor : "rgba(0, 0, 0, 0.55)",
		inset           : "0",
		position        : "absolute",
		display         : "none",
		zIndex          : "5"
	},
	overlayShow: {
		backgroundColor : "rgba(0, 0, 0, 0.55)",
		inset           : "0",
		position        : "absolute",
		display         : "block",
		zIndex          : "5"
	},
	deleteModalWrapper: {
		position        : "absolute",
		zIndex          : "10",
		backgroundColor : theme.other.colors.dialog.primary,
		borderRadius    : "13px",
		top             : "30%",
		width           : "calc(100% - 40px)"
	},
	topSection: {
		padding        : "2rem 0.2rem",
		display        : "flex",
		justifyContent : "center",
		alignItems     : "center",
		flexDirection  : "column",
		borderBottom   : `1px solid ${ theme.other.colors.border.primary }`
	},
	bottomSection: {
		display: "flex"

	},
	headerText: {
		textAlign    : "center",
		fontWeight   : "500",
		marginBottom : "10px"
	},
	text1: {
		textAlign : "center",
		color     : theme.other.colors.text.secondary
	},
	text2: {
		textAlign : "center",
		color     : theme.other.colors.text.secondary
	},
	actionButtons: {
		width          : "50%",
		display        : "flex",
		justifyContent : "center",
		alignItems     : "center",
		padding        : "2rem",
		cursor         : "pointer",
		fontWeight     : "500"
	},
	cancelButtonColor: {
		background              : "linear-gradient(to bottom, #126bd5, #439aff)",
		borderBottomRightRadius : "10px",
		color                   : theme.other.paletteNew.secondaryWhite
	},
	tickIcon: {
		filter     : theme.other.darkMode ? "" : "invert(1)",
		width      : "20px",
		height     : "20px",
		marginLeft : "5px"
	}

} ) );
